export const CART_ITEM_STATUS = {
  IN_CART: "IN_CART",
  SAVED_FOR_LATER: "SAVED_FOR_LATER",
  CHECKED_OUT: "CHECKED_OUT",
  PAID: "PAID",
  IN_BANK_TRANSFER: "IN_BANK_TRANSFER",
} as const;
